<div style="z-index: 2" class="d-flex justify-content-center align-items-center fullPageWrapper" *ngIf="loading">
  <sb-icon class="loadingSpinnerSVG" style="font-size: 2rem" icon="loadingBlockAnimation"
           [animationOptions]="{autoplay: true, loop:true}"></sb-icon>
  <span>{{ 'lang.globals.pleaseWait' | translate }}</span>
</div>
<ng-container *ngIf="!loading">
  <div class="row">
    <div class="col-lg-4 col-12">
      <sb-card [halfHeight]="true">
        <div card-body>
          <sb-chart #pieChartContainer chartType="pieChart"
                    [chartData]="pieChartData"></sb-chart>
        </div>
      </sb-card>
      <sb-card [halfHeight]="true">
        <div card-body>
          <sb-comp-info-card #infoCard [reportingObj]="getReportingObjForInfoCard()"
                             [selectedField]="selectedField"></sb-comp-info-card>
        </div>
      </sb-card>
    </div>
    <div class="col-lg-8 col-12">
      <sb-card classes="no-border">
        <div card-header>
          <ng-container [ngSwitch]="selectedField">
            <!-- the same view can be shown in more than one case -->
            <h3 *ngSwitchCase="'mediumGroup'">{{ 'lang.globals.mediumGroups' | translate }}</h3>
            <h3 *ngSwitchCase="'medium'">{{ 'lang.globals.medias' | translate }}</h3>
            <!--default case when there are no matches -->
            <h3 *ngSwitchDefault>Elements</h3>
          </ng-container>
        </div>
        <div card-fit>
          <ng-scrollbar class="w-100" [track]="'all'" [autoHeightDisabled]="false">
            <table class="table table-hover bl mb-3">
              <thead>
              <tr>
                <th class="tableBg"></th>
                <th class="tableBg text-end">{{ 'lang.globals.playouts' | translate }}</th>
                <th class="tableBg text-end">{{ 'lang.globals.inPercent' | translate }}</th>
                <th class="tableBg">{{ 'lang.globals.name' | translate }}</th>
                <th class="tableBg">{{ 'lang.globals.modifiedAt' | translate }}</th>
                <th class="tableBg text-end">
                  {{ 'lang.globals.actions' | translate }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr (mouseleave)="setHoverStatus(0, i, false)"
                  (mouseenter)="setHoverStatus(0, i,true)"
                  *ngFor="let ele of reportingObj; index as i">
                <td>
                  <span class="mr-2" [style.background]="'#' + util.renderStringColor(ele?.element?.name)"
                        style="display: inline-block; width: 8px; height: 8px; border-radius: 50%"></span>
                </td>
                <td class="text-end">
                  <span class="font-weight-bold">
                    {{ !playoutsNumber ? util.parseTimeToDuration(ele.report.aggregated.v1) : stringTransformation.truncateNumber(ele.report.aggregated.v0) }}
                  </span>
                </td>
                <td class="text-end">
                  <span class="font-weight-bold">
                    {{ calcPercentageVal(ele.report.aggregated.v0, ele.report.totalNumber.v0) }}
                  </span>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <ng-container [ngSwitch]="selectedField">
                      <div class="pictureFrame mr-3">
                        <!-- the same view can be shown in more than one case -->
                        <sb-comp-medium *ngSwitchCase="'mediumGroup'" [background]="true"
                                        [hoverPreview]="true"
                                        [medium]="ele?.element.preview"></sb-comp-medium>
                        <sb-comp-medium *ngSwitchCase="'medium'" [background]="true"
                                        [hoverPreview]="true" [medium]="ele?.element"></sb-comp-medium>
                        <div *ngSwitchCase="'product'" class="backgroundFrame"
                             [style.backgroundImage]="ele?.element?.depiction?.url ? 'url(' + ele?.element?.depiction?.url + ')' : ''">
                        </div>
                        <div *ngSwitchCase="'productCategory'" class="backgroundFrame"
                             [style.backgroundImage]="ele?.element?.illustration?.url ? 'url(' + ele?.element?.illustration?.url + ')' : ''">
                        </div>
                        <!--default case when there are no matches -->
                      </div>
                    </ng-container>
                    <sb-comp-name-wrapper
                      *ngIf="onlyMediumElement != ele" container="body"
                      ngbTooltip="{{ 'lang.globals.openDetails' | translate }}"
                      (click)="selectElement(ele?.element?.id)">
                      <span firstLine [innerHTML]="ele?.element?.name | truncate : 50"></span>
                      <span secondLine [innerHTML]="ele?.element?.description | truncate : 50"></span>
                      <span thirdLine
                            *ngIf="selectedField === 'mediumGroup'">{{ ele?.element?.mediaCount }} {{ ele?.element?.mediaCount === 1 ? ('lang.globals.motive'|translate) : ('lang.globals.motives'|translate) }}</span>
                      <span thirdLine *ngIf="selectedField === 'product'">{{ renderProductCode(ele?.element) }}</span>
                    </sb-comp-name-wrapper>
                  </div>
                </td>
                <td>
                  <sb-comp-display-modified [data]="ele?.element"></sb-comp-display-modified>
                </td>
                <td class="text-end">
                  <a ngbTooltip="{{ 'lang.globals.openDetails' | translate }}" container="body"
                     (click)="selectElement(ele.element.id)">
                    <button class="btn btn-primary">
                      <sb-icon icon="details"></sb-icon>
                    </button>
                  </a>
                </td>
              </tr>

              <!-- campaigns without selectedField-->

              <tr *ngIf="onlyMediumElement"
                  (mouseleave)="setHoverStatus(1, reportingObj.length, false)"
                  (mouseenter)="setHoverStatus(1, reportingObj.length,true)"
                  [ngClass]="{'tw-opacity-50': onlyMediumElement}">
                <td>
                  <span class="mr-2" [style.background]="'#efefef'"
                        style="display: inline-block; width: 8px; height: 8px; border-radius: 50%"></span>
                </td>
                <td class="text-end">
                  <span class="font-weight-bold">
                    {{ !playoutsNumber ? util.parseTimeToDuration(onlyMediumElement?.report?.aggregated?.v1) : stringTransformation.truncateNumber(onlyMediumElement?.report?.aggregated?.v0) }}
                  </span>
                </td>
                <td class="text-end">
                  <span class="font-weight-bold">
                    {{ calcPercentageVal(onlyMediumElement.report.aggregated?.v0, onlyMediumElement.report.totalNumber?.v0) }}
                  </span>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <p class="font-weight-bold m-0" [innerHTML]="getOnlyMotiveElementText(true)"></p>
                  </div>
                </td>
                <td>
                  <!-- last changed table element -->
                </td>
                <td class="text-end">
                  <!-- details button table element -->
                </td>
              </tr>


              <ng-container *ngIf="additionalReportingObj && additionalReportingObj.length>0">
                <tr class="tw-opacity-50" [hidden]="selectedField ==='medium'">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{ getOnlyMotiveElementText(false) }}</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr *ngFor="let ele of additionalReportingObj;index as i"
                    (mouseleave)="setHoverStatus(2, i,false)"
                    (mouseenter)="setHoverStatus(2, i, true)">
                  <td>
                    <span class="mr-2" [style.background]="'#efefef'"
                          style="display: inline-block; width: 8px; height: 8px; border-radius: 50%"></span>
                  </td>
                  <td class="text-end">
                    <span class="font-weight-bold">
                      {{ !playoutsNumber ? util.parseTimeToDuration(ele?.report?.aggregated?.v1) : stringTransformation.truncateNumber(ele?.report?.aggregated?.v0) }}
                    </span>
                  </td>
                  <td class="text-end">
                    <span class="font-weight-bold">
                      {{ calcPercentageVal(ele?.report.aggregated.v0, ele?.report.totalNumber.v0) }}
                    </span>
                  </td>
                  <td>
                    <sb-comp-image-name-wrapper [medium]="ele?.element" [background]="true">
                      <span firstLine [innerHTML]="ele?.element?.name | truncate : 45"></span>
                      <span secondLine [innerHTML]="ele.element?.description | truncate:45"></span>
                    </sb-comp-image-name-wrapper>
                  </td>
                  <td>
                    <sb-comp-display-modified [data]="ele?.element"></sb-comp-display-modified>
                  </td>
                  <td class="text-end">
                    <!--<a container="body" ngbTooltip="{{ 'lang.globals.openDetails' | translate }}" placement="left" (click)="selectElement(ele?.element.id)">
                                  <button class="btn btn-hover-primary">
                                    <fa-icon icon="chart-line"></fa-icon>
                                  </button>
                                </a>-->
                  </td>
                </tr>
              </ng-container>
              </tbody>
            </table>
          </ng-scrollbar>
        </div>
      </sb-card>
      <!--    <sb-card classes="no-border" [halfHeight]="true">
            <div card-header>
              <h3>Share of Voice Overview</h3>
            </div>
            <div card-header-more>
              <div class="font-weight-normal text-end" style="font-size: 12px" #playerLineChartLegend></div>
            </div>
            <div card-body>
              <sb-chart chartType="lineChart" [chartData]="playerLineChart"></sb-chart>
            </div>
          </sb-card>
          <sb-card [halfHeight]="true">
            <div card-header>
              <h3>Share of Voice Overview</h3>
            </div>
            <div card-body>
              <sb-chart chartType="barChart" [chartData]="playerLineChart"></sb-chart>
            </div>
          </sb-card>-->
    </div>
  </div>
</ng-container>
